module.exports = __webpack_public_path__ + "public/img/jifenShop.4fc6a51b.png";